import { render } from "./separator.vue?vue&type=template&id=3e1fa254"
import script from "./separator.vue?vue&type=script&lang=js"
export * from "./separator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__